// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"24":"companies","417":"extensions","644":"account"}[chunkId] || chunkId) + "." + {"24":"8e3c7aac","393":"d5768a51","417":"c775fbbc","644":"e9cce8fc"}[chunkId] + ".css";
};